import { chapterDifficulty } from "interfaces/courses"
import { Dispatch, SetStateAction, createContext, useContext, useEffect, useState } from "react"

interface FilterState {
  difficulty: chapterDifficulty | "both"
  setDifficulty: Dispatch<SetStateAction<chapterDifficulty | "both">>
  selectedTags: string[]
  setSelectedTags: Dispatch<SetStateAction<string[]>>
  pace: number
  setPace: Dispatch<SetStateAction<number>>
}

export const CoursesFilterContext = createContext<FilterState>({
  difficulty:"both",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setDifficulty:() => {},
  selectedTags:[],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelectedTags:() => {},
  pace:3,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setPace:() => {},
})

export const useCoursesFilterContext = () => useContext(CoursesFilterContext)

export const CoursesFilterContextProvider = ({
  children
}:{
  children: React.ReactNode;
}) => {
  const [difficulty, setDifficulty] = useState<chapterDifficulty | "both">("both")
  const [selectedTags, setSelectedTags] = useState<string[]>([])
  const [pace, setPace] = useState<number>(1)

  // get tags from fb
  useEffect(() => {
    
    const pace = window.localStorage.getItem("pace")

    if (!pace) {
      setPace(3)
      window.localStorage.setItem("pace", "3")
      return 
    }
    
    setPace(parseInt(pace))
  }, []);

  const contextValue = {
    difficulty,
    setDifficulty,
    selectedTags,
    setSelectedTags,
    pace,
    setPace
  }

  return (
    <CoursesFilterContext.Provider value={contextValue}>
      {children}
    </CoursesFilterContext.Provider>
  )
}
